import { fetcher } from "helpers/fetcher";

import {
  TAddStaffMaternityChldrenLeaveReq,
  TAddStaffMaternityChldrenLeaveRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addEmployeeMaternityChildrenLeave = async (
  payload: TAddStaffMaternityChldrenLeaveReq
) => {
  return await fetcher<
    TAddStaffMaternityChldrenLeaveRes,
    TAddStaffMaternityChldrenLeaveReq["data"]
  >(ENDPOINT.USER.ADD_EMPLOYEE_MATERNITY_CHILDREN_LEAVE, {
    data: payload.data,
    headers: {
      [API_HEADER.USER_ID]: payload.idUser,
      [API_HEADER.VERSION]:
        ENDPOINT.USER.ADD_EMPLOYEE_MATERNITY_CHILDREN_LEAVE.version,
    },
  });
};

export const mutationAddEmployeeMaternityChldrenLeave = async (
  payload: TAddStaffMaternityChldrenLeaveReq
) => {
  return (await addEmployeeMaternityChildrenLeave(payload)).data.message;
};

mutationAddEmployeeMaternityChldrenLeave._key = (
  payload: TAddStaffMaternityChldrenLeaveReq
) => [ENDPOINT.USER.ADD_EMPLOYEE_MATERNITY_CHILDREN_LEAVE.url, payload];
